import { Button } from "@/components/ui/button";
import { daysRangeOptions } from "@/lib/options/daysRangeOptions";
import { useAppStore } from "@/store/app";

export function DateRangeSelector() {
  const selectedRange = useAppStore((s) => s.selectedDaysRange);
  const setSelectedDaysRange = useAppStore((s) => s.setSelectedDaysRange);

  return (
    <div className="px-6 mb-6">
      <div className="flex rounded-full overflow-hidden p-1 shadow-xs bg-bg-light">
        {daysRangeOptions.map((option) => (
          <Button
            key={option.value}
            variant="ghost"
            className={`flex-1 rounded-full py-1 px-0 text-sm ${
              selectedRange === option.value
                ? "bg-primary text-white"
                : "text-tx-muted"
            }`}
            onClick={() => setSelectedDaysRange(option.value)}
          >
            {option.short_label}
          </Button>
        ))}
      </div>
    </div>
  );
}
